<template>
  <div class="onboarding" data-cy="onboarding-pricing">
    <TopBar @close="onClose" closeButton />
    <PricingStigg v-if="usesStiggIntegration" :theme="theme" />
    <Pricing v-else :theme="theme" onboardingFlow />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import TopBar from '@/components/Onboarding/TopBar';
import Pricing from '@/views/Pricing';
import PricingStigg from '@/views/PricingStigg';

export default {
  data() {
    return { theme: 'dark' };
  },
  components: {
    TopBar,
    Pricing,
    PricingStigg
  },
  mounted() {
    this.applyTheme(this.theme, 'onboarding');
    document.body.style.overflowY = 'auto';
  },
  computed: {
    ...mapState('teams', { team: 'currentItem' }),
    usesStiggIntegration() {
      return this.team?.uses_stigg_integration;
    }
  },
  methods: {
    onClose() {
      const { params } = this.$route;
      this.$router.push({ name: 'team', params });
      this.$trackEvent('onboarding-pricing.close-button.click');
    }
  }
};
</script>
